import React from 'react';
import { NamedLink } from '../../components';
import { FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';
import css from './BAGReadyToRent.css';

const BAGReadyToRent = props => {
  const {
    isAuthenticated,
    onLoginOrSignupClick,
  } = props;

  return (
    <section className={css.root}>
      <div className={css.readyToShareSection}>
        <div className={css.textBox}>
          <h6 className={css.title}>
            <FormattedMessage
              id="BecomeAGuestPage.readyToShareTitle"
              values={{ newlineDesktop: <span className={css.newlineDesktop}><br/></span>, newlineMobile: <span className={css.newlineMobile}><br /></span> }}
            />
          </h6>
          {isAuthenticated &&
            <NamedLink
              name="SearchPage"
              to={{
                search:
                  'bounds=1.54840194%2C103.93560548%2C1.20243284%2C103.68841309',
              }}
              className={classNames(css.listYourCar)}
            >
              <FormattedMessage id="BecomeAGuestPage.searchForCars" />
            </NamedLink>
          }
          {!isAuthenticated &&
            <NamedLink
              name="SignupPage"
              className={classNames(css.listYourCar)}
              onClick={() => onLoginOrSignupClick('signup')}
            >
              <FormattedMessage id="BecomeAGuestPage.joinUsNowButton" />
            </NamedLink>
          }
        </div>
      </div>
    </section>
  );
};

export default BAGReadyToRent;
